<div class="bmc-sync-data__wrapper">
  <div class="bmc-syncdata-import-step4">
    <h2 class="bmc-syncdata-import-step4__title">{{ 'SYNC_DATA.IMPORTING_FILE' | translate}}</h2>
  </div>
</div>